import {
  LIBRARY_ITEM_HUB_PAGE_REQUEST,
  LIBRARY_ITEM_HUB_SET_ITEM_LIST,
  LIBRARY_ITEM_HUB_SET_OUTLETS,
  LIBRARY_ITEM_HUB_SET_FILTER_STATE,
  LIBRARY_ITEM_HUB_SET_REWARD_ITEM_LIST,
  LIBRARY_ITEM_HUB_SET_REWARD_CATEGORY_LIST,
  LIBRARY_ITEM_HUB_SET_REWARD_ITEM_VARIANT_OF,
  LIBRARY_ITEM_HUB_SET_POINT_GAIN_ITEM_LIST,
  LIBRARY_ITEM_HUB_SET_POINT_GAIN_CATEGORY_LIST,
  LIBRARY_ITEM_HUB_SET_POINT_GAIN_ITEM_VARIANT_OF,
  LIBRARY_ITEM_HUB_SET_META_ITEMS,
  LIBRARY_ITEM_HUB_TOGGLE_WRITE_MODE,
  LIBRARY_ITEM_HUB_ON_SELECT_ITEM,
  LIBRARY_ITEM_HUB_SET_ITEM_DETAIL,
  LIBRARY_ITEM_HUB_LIST_CATEGORY_WITH_UNCATEGORIZED_REQUEST,
  LIBRARY_ITEM_HUB_SET_CATEGORY_LIST,
  LIBRARY_ITEM_HUB_SET_PREVIOUS_ITEM_FORM,
  LIBRARY_ITEM_HUB_SET_MODIFIERS,
  LIBRARY_ITEM_HUB_ON_CLICK_CREATE_ITEM,
  LIBRARY_ITEM_HUB_SET_FILTER_ITEM,
  LIBRARY_ITEM_HUB_ON_CLICK_BTN_ITEM_VARIANT,
  LIBRARY_ITEM_HUB_SHOW_ITEM_VARIANT_MODAL,
  LIBRARY_ITEM_HUB_HIDE_ITEM_VARIANT_MODAL,
  LIBRARY_ITEM_HUB_ON_CANCEL_ITEM_VARIANT_MODAL,
  LIBRARY_ITEM_HUB_ON_CONFIRM_ITEM_VARIANT_MODAL,
  LIBRARY_ITEM_HUB_ON_CLICK_BTN_SALES_TYPE,
  LIBRARY_ITEM_HUB_SHOW_SALES_TYPE_MODAL,
  LIBRARY_ITEM_HUB_HIDE_SALES_TYPE_MODAL,
  LIBRARY_ITEM_HUB_ON_CANCEL_SALES_TYPE_MODAL,
  LIBRARY_ITEM_HUB_ON_CONFIRM_SALES_TYPE_MODAL,
  LIBRARY_ITEM_HUB_ON_CLICK_BTN_MODIFIER,
  LIBRARY_ITEM_HUB_SHOW_MODIFIER_MODAL,
  LIBRARY_ITEM_HUB_HIDE_MODIFIER_MODAL,
  LIBRARY_ITEM_HUB_ON_CONFIRM_MODIFIER_MODAL,
  LIBRARY_ITEM_HUB_ON_CANCEL_MODIFIER_MODAL,
  LIBRARY_ITEM_HUB_ON_CLICK_CANCEL,
  LIBRARY_ITEM_HUB_SHOW_DELETE_MODAL,
  LIBRARY_ITEM_HUB_HIDE_DELETE_MODAL,
  LIBRARY_ITEM_HUB_SHOW_CONFIRM_ITEM_MODAL,
  LIBRARY_ITEM_HUB_HIDE_CONFIRM_ITEM_MODAL,
  LIBRARY_ITEM_HUB_SUBMIT_FORM_CREATE,
  LIBRARY_ITEM_HUB_SUBMIT_FORM_UPDATE,
  LIBRARY_ITEM_HUB_SET_CHANNEL_ASYNC_JOB,
  LIBRARY_ITEM_HUB_ON_DELETE_ITEM,
  LIBRARY_ITEM_HUB_HANDLE_ERROR_ASYNC_JOB,
  LIBRARY_ITEM_HUB_ON_CHECKED_SALES_TYPE,
  LIBRARY_ITEM_HUB_SET_LIST_OUTLET_FORM,
  LIBRARY_ITEM_HUB_ADD_OUTLET_LIST,
  LIBRARY_ITEM_HUB_ITEM_REQUEST,
} from './constants';

export const pageRequest = () => {
  return { type: LIBRARY_ITEM_HUB_PAGE_REQUEST, payload: {} };
};

export const setItems = (items) => {
  return { type: LIBRARY_ITEM_HUB_SET_ITEM_LIST, payload: { items } };
};

export const setMetaItems = (meta) => {
  return { type: LIBRARY_ITEM_HUB_SET_META_ITEMS, payload: { meta } };
};

export const setOutlets = (outlets) => {
  return {
    type: LIBRARY_ITEM_HUB_SET_OUTLETS,
    payload: { outlets },
  };
};

export const setFilterState = (
  categoryId,
  outletId,
  typeInventoryId,
  keyword
) => {
  return {
    type: LIBRARY_ITEM_HUB_SET_FILTER_STATE,
    payload: { categoryId, outletId, typeInventoryId, keyword },
  };
};

export const setRewardItemList = (items) => {
  return { type: LIBRARY_ITEM_HUB_SET_REWARD_ITEM_LIST, payload: { items } };
};

export const setRewardCategoryList = (categories) => {
  return {
    type: LIBRARY_ITEM_HUB_SET_REWARD_CATEGORY_LIST,
    payload: { categories },
  };
};

export const setRewardItemVariantList = (itemVariants) => {
  return {
    type: LIBRARY_ITEM_HUB_SET_REWARD_ITEM_VARIANT_OF,
    payload: { itemVariants },
  };
};

export const setPointGainItemList = (items) => {
  return {
    type: LIBRARY_ITEM_HUB_SET_POINT_GAIN_ITEM_LIST,
    payload: { items },
  };
};

export const setPointGainCategoryList = (categories) => {
  return {
    type: LIBRARY_ITEM_HUB_SET_POINT_GAIN_CATEGORY_LIST,
    payload: { categories },
  };
};

export const setPointGainItemVariantList = (itemVariants) => {
  return {
    type: LIBRARY_ITEM_HUB_SET_POINT_GAIN_ITEM_VARIANT_OF,
    payload: { itemVariants },
  };
};

export const setToggleWriteMode = (writeMode) => ({
  type: LIBRARY_ITEM_HUB_TOGGLE_WRITE_MODE,
  payload: { writeMode },
});

export const onSelectItem = (item) => ({
  type: LIBRARY_ITEM_HUB_ON_SELECT_ITEM,
  payload: { item },
});

export const setItemDetail = (item) => {
  return { type: LIBRARY_ITEM_HUB_SET_ITEM_DETAIL, payload: { item } };
};

export const listCategoryWithUncategorizedRequest = () => {
  return {
    type: LIBRARY_ITEM_HUB_LIST_CATEGORY_WITH_UNCATEGORIZED_REQUEST,
    payload: {},
  };
};

export const setCategories = (categories) => {
  return { type: LIBRARY_ITEM_HUB_SET_CATEGORY_LIST, payload: { categories } };
};

export const setModifiers = (modifiers) => {
  return { type: LIBRARY_ITEM_HUB_SET_MODIFIERS, payload: { modifiers } };
};

export const setPreviousItemForm = (previousItemForm) => {
  return {
    type: LIBRARY_ITEM_HUB_SET_PREVIOUS_ITEM_FORM,
    payload: { previousItemForm },
  };
};

export const onClickCreateItem = () => {
  return {
    type: LIBRARY_ITEM_HUB_ON_CLICK_CREATE_ITEM,
  };
};

export const onChangeFilterItemHub = (payload) => {
  return {
    type: LIBRARY_ITEM_HUB_SET_FILTER_ITEM,
    payload,
  };
};

export const onClickBtnItemVariant = (itemForm) => ({
  type: LIBRARY_ITEM_HUB_ON_CLICK_BTN_ITEM_VARIANT,
  payload: { itemForm },
});

export const showItemVariantModal = () => {
  return { type: LIBRARY_ITEM_HUB_SHOW_ITEM_VARIANT_MODAL, payload: {} };
};

export const hideItemVariantModal = () => {
  return { type: LIBRARY_ITEM_HUB_HIDE_ITEM_VARIANT_MODAL, payload: {} };
};

export const onConfirmItemVariantModal = (value, itemForm) => {
  return {
    type: LIBRARY_ITEM_HUB_ON_CONFIRM_ITEM_VARIANT_MODAL,
    payload: { value, itemForm },
  };
};

export const onCancelItemVariantModal = (previousItemForm) => {
  return {
    type: LIBRARY_ITEM_HUB_ON_CANCEL_ITEM_VARIANT_MODAL,
    payload: { previousItemForm },
  };
};

export const onClickBtnSalesType = (itemForm) => {
  return {
    type: LIBRARY_ITEM_HUB_ON_CLICK_BTN_SALES_TYPE,
    payload: { itemForm },
  };
};

export const showSalesTypeModal = () => {
  return { type: LIBRARY_ITEM_HUB_SHOW_SALES_TYPE_MODAL, payload: {} };
};

export const hideSalesTypeModal = () => {
  return { type: LIBRARY_ITEM_HUB_HIDE_SALES_TYPE_MODAL, payload: {} };
};

export const onCancelSalesTypeModal = (previousItemForm) => {
  return {
    type: LIBRARY_ITEM_HUB_ON_CANCEL_SALES_TYPE_MODAL,
    payload: { previousItemForm },
  };
};

export const onConfirmSalesTypeModal = (value) => {
  return {
    type: LIBRARY_ITEM_HUB_ON_CONFIRM_SALES_TYPE_MODAL,
    payload: { value },
  };
};

export const onClickBtnModifier = (itemForm) => ({
  type: LIBRARY_ITEM_HUB_ON_CLICK_BTN_MODIFIER,
  payload: { itemForm },
});

export const showModifierModal = () => {
  return { type: LIBRARY_ITEM_HUB_SHOW_MODIFIER_MODAL, payload: {} };
};

export const hideModifierModal = () => {
  return { type: LIBRARY_ITEM_HUB_HIDE_MODIFIER_MODAL, payload: {} };
};

export const onCancelModifierModal = (previousItemForm) => {
  return {
    type: LIBRARY_ITEM_HUB_ON_CANCEL_MODIFIER_MODAL,
    payload: { previousItemForm },
  };
};

export const onConfirmModifierModal = (value) => {
  return {
    type: LIBRARY_ITEM_HUB_ON_CONFIRM_MODIFIER_MODAL,
    payload: { value },
  };
};

export const onClickCancel = () => {
  return { type: LIBRARY_ITEM_HUB_ON_CLICK_CANCEL, payload: {} };
};

export const showDeleteModal = () => {
  return { type: LIBRARY_ITEM_HUB_SHOW_DELETE_MODAL };
};

export const hideDeleteModal = () => {
  return { type: LIBRARY_ITEM_HUB_HIDE_DELETE_MODAL };
};

export const showConfirmItemModal = () => {
  return { type: LIBRARY_ITEM_HUB_SHOW_CONFIRM_ITEM_MODAL };
};

export const hideConfirmItemModal = () => {
  return { type: LIBRARY_ITEM_HUB_HIDE_CONFIRM_ITEM_MODAL };
};

export const submitFormCreate = (values) => {
  return {
    type: LIBRARY_ITEM_HUB_SUBMIT_FORM_CREATE,
    payload: { values },
  };
};

export const submitFormUpdate = (values) => {
  return {
    type: LIBRARY_ITEM_HUB_SUBMIT_FORM_UPDATE,
    payload: { values },
  };
};

export const onDeleteitem = (values) => {
  return {
    type: LIBRARY_ITEM_HUB_ON_DELETE_ITEM,
    payload: { values },
  };
};

export function setEventAsyncJob(channelName) {
  return {
    type: LIBRARY_ITEM_HUB_SET_CHANNEL_ASYNC_JOB,
    payload: { channelName },
  };
}

export function handleErrorAsyncJob(error) {
  return {
    type: LIBRARY_ITEM_HUB_HANDLE_ERROR_ASYNC_JOB,
    payload: { error },
  };
}

export function onCheckedSalesType(event, formValue) {
  return {
    type: LIBRARY_ITEM_HUB_ON_CHECKED_SALES_TYPE,
    payload: { event, formValue },
  };
}

export function setOutletListForm(outlets, page, totalpage) {
  return {
    type: LIBRARY_ITEM_HUB_SET_LIST_OUTLET_FORM,
    payload: { outlets, page, totalpage },
  };
}

export function addOutletListForm() {
  return {
    type: LIBRARY_ITEM_HUB_ADD_OUTLET_LIST,
  };
}

export function getItemsRequest(query, previousItems) {
  return {
    type: LIBRARY_ITEM_HUB_ITEM_REQUEST,
    payload: { query, previousItems },
  };
}
